import React from 'react';
import { useFormContext } from 'react-hook-form';
import { TextField as MUITextField } from '@mui/material';
import { formatNumber, parseEuroNumber } from '../utils/helper';

const EuroNumberInput = (props) => {
  const { name = '', label, ...otherProps } = props;

  const {
    register,
    setValue,
    watch,
    formState: { errors },
  } = useFormContext();

  const handleChange = (e) => {
    const parsedValue = parseEuroNumber(e.target.value.replace(/\D/g, ''));
    setValue(name, parsedValue, { shouldDirty: true, shouldValidate: true });
  };

  return (
    <MUITextField
      label={label}
      fullWidth
      margin='normal'
      {...register(name)}
      value={formatNumber(watch(name) || '') === '0' ? '' : formatNumber(watch(name) || '')}
      onChange={handleChange}
      onBlur={handleChange}
      error={!!errors?.[name]}
      helperText={errors?.[name] ? errors?.[name]?.message : ''}
      {...otherProps}
    />
  );
};

export default EuroNumberInput;
